import { useSelector } from 'react-redux';

const userIsUserAuth = () => {
  return useSelector((state) => state.auth.access !== null);
};

export default userIsUserAuth;
